export async function fetchReport({
  userId,
  token,
  sessionId = null,
  organizationId = null,
  gameId = null,
  email = null,
  name = null,
  database = null,
  databaseName = null,
  db = null,
  dbname = null,
  lobby = null,
  lobbyName = null,
}) {
  const body = {
    userId,
    ...(sessionId ? { sessionId } : {}),
    ...(organizationId ? { organizationId } : {}),
    ...(gameId ? { gameId } : {}),
    ...(email ? { email } : {}),
    ...(name ? { name } : {}),
    ...(database ? { database } : {}),
    ...(databaseName ? { databaseName } : {}),
    ...(db ? { db } : {}),
    ...(dbname ? { dbname } : {}),
    ...(lobby ? { lobby } : {}),
    ...(lobbyName ? { lobbyName } : {}),
  };
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/fetchReport`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  if (!resp.ok) {
    const data = await resp.json().catch(() => ({}));
    throw new Error(data?.message || 'Failed to fetch report');
  }
  return resp.json(); 
}
